import { CampaignType, campaignTypes } from '@retail/campaign/types';
import { safeTextRegex } from '@retail/form/validation';
import { AppTFunction } from '@retail/app/i18n';
import * as yup from 'yup';
import dayjs from 'dayjs';

export const MAX_CAMPAIGN_NAME_LENGTH = 40;
export const MAX_CAMPAIGN_DESCRIPTION_LENGTH = 200;

const baseCampaignSchema = (t: AppTFunction) =>
  yup.object({
    campaignName: yup
      .string()
      .required(t('campaign.error.requiredField'))
      .max(MAX_CAMPAIGN_NAME_LENGTH, t('campaign.error.nameMax', { count: MAX_CAMPAIGN_NAME_LENGTH }))
      .matches(safeTextRegex, t('validation.safeText')),
    description: yup
      .string()
      .max(MAX_CAMPAIGN_DESCRIPTION_LENGTH, t('campaign.error.descriptionMax', { count: MAX_CAMPAIGN_DESCRIPTION_LENGTH }))
      .matches(safeTextRegex, t('validation.safeText')),
    validFrom: yup.date().required(t('campaign.error.requiredField')),
    validTo: yup
      .date()
      .required(t('campaign.error.requiredField'))
      .when(
        'validFrom',
        (validFrom, schema) =>
          validFrom && schema.min(dayjs(validFrom), t('campaign.error.beforeDateError'))
      ),
    purchasePeriodFrom: yup.date().required(t('campaign.error.requiredField')),
    purchasePeriodTo: yup
      .date()
      .when(
        'purchasePeriodFrom',
        (purchasePeriodFrom, schema) =>
          purchasePeriodFrom &&
          schema.min(dayjs(purchasePeriodFrom), t('campaign.error.beforeDateError'))
      )
      .required(t('campaign.error.requiredField')),
  });

export const memberCampaignSchema = (t: AppTFunction) => baseCampaignSchema(t);

export const brandCampaignSchema = (t: AppTFunction) =>
  baseCampaignSchema(t).concat(
    yup.object({
      brands: yup.array(yup.string().default('')).default([]).nullable(),
      campaignType: yup
        .mixed<CampaignType>()
        .oneOf([...Object.values(campaignTypes)])
        .defined(t('campaign.error.requiredField'))
        .required(t('campaign.error.requiredField')),
      mandatory: yup.boolean(),
    })
  );

export type MemberCampaignSchema = yup.InferType<ReturnType<typeof memberCampaignSchema>>;
export type BrandCampaignSchema = yup.InferType<ReturnType<typeof brandCampaignSchema>>;
